export default __webpack_public_path__ + "static/char-s-12-jp-9ca0d041821f7890a3bed902d9d6f718.png";